export default __webpack_public_path__ + "static/retailer-ff5771d07b9a4cd6099a5a9e71387929.jpg";